import React from 'react';
import PropTypes from 'prop-types';
import AccessMethodCreateContainer from 'pages/accessPoints/access-methods/create/AccessMethodCreateContainer';
import AccessMethodEditContainer from 'pages/accessPoints/access-methods/edit/AccessMethodEditContainer';
import AccessPointCreateContainer from 'pages/accessPoints/create/AccessPointCreateContainer';
import AccessPointEditContainer from 'pages/accessPoints/edit/AccessPointEditContainer';
import AccessPointShowContainer from 'pages/accessPoints/show/AccessPointShowContainer';
import AccountsCreate from 'pages/accounts/create/AccountsCreateContainer';
import AccountsEditContainer from 'pages/accounts/edit/AccountsEditContainer';
import AccountsListContainer from 'pages/accounts/list/AccountsListContainer';
import AccountsShowContainer from 'pages/accounts/show/AccountsShowContainer';
import ApiKeysCreateContainer from 'pages/api-keys/create/ApiKeysCreateContainer';
import ApiKeysEditContainer from 'pages/api-keys/edit/ApiKeysEditContainer';
import ApiKeysListContainer from 'pages/api-keys/list/ApiKeysListContainer';
import BookingsEditContainer from 'pages/bookings/edit/BookingsEditContainer';
import BookingShowContainer from 'pages/bookings/show/BookingShowContainer';
import BookingsListContainer from 'pages/bookings/list/BookingsListContainer';
import BookingStatsListContainer from 'pages/bookingStats/list/BookingStatsListContainer';
import BookingToolContainer from 'pages/booking-tool/BookingToolContainer';
import CampaignsCreateContainer from 'pages/campaigns/create/CampaignsCreateContainer';
import CampaignsEditContainer from 'pages/campaigns/edit/CampaignsEditContainer';
import CampaignsListContainer from 'pages/campaigns/list/CampaignsListContainer';
import CampaignsShowContainer from 'pages/campaigns/show/CampaignsShowContainer';
import CurrentAccountEditContainer from 'pages/accounts/current-account/edit/CurrentAccountEditContainer';
import CurrentAccountShowContainer from 'pages/accounts/current-account/show/CurrentAccountShowContainer';
import Dashboard from 'pages/Dashboard';
import DiscountCodesCreateContainer from 'pages/discountCodes/create/DiscountCodesCreateContainer';
import DiscountCodesEditContainer from 'pages/discountCodes/edit/DiscountCodesEditContainer';
import DiscountCodesListContainer from 'pages/discountCodes/list/DiscountCodesListContainer';
import DiscountsCreateContainer from 'pages/discounts/create/DiscountsCreateContainer';
import DiscountsEditContainer from 'pages/discounts/edit/DiscountsEditContainer';
import DiscountsListContainer from 'pages/discounts/list/DiscountsListContainer';
import DiscountsShowContainer from 'pages/discounts/show/DiscountsShowContainer';
import InvitationRequestsContainer from 'pages/invitations/requests/InvitationRequestsContainer';
import InvitationsCreateContainer from 'pages/invitations/list/create/InvitationsCreateContainer';
import InvitationsListContainer from 'pages/invitations/list/InvitationsListContainer';
import InvoiceShowContainer from 'pages/invoices/show/InvoiceShowContainer';
import InvoicesListContainer from 'pages/invoices/list/InvoicesListContainer';
import LoginContainer from 'pages/login/LoginContainer';
import NotAllowedCard from 'pages/UserNotAllowed/UserNotAllowed';
import Page from './Page';
import PageNotFound from 'pages/NotFound/PageNotFound';
import PasswordForgottenContainer from 'pages/password-forgotten/PasswordForgottenContainer';
import PointsOfInterestCreate from 'pages/pointsofinterest/create/PointsOfInterestCreateContainer';
import PointsOfInterestEditContainer from 'pages/pointsofinterest/edit/PointsOfInterestEditContainer';
import PointsOfInterestListContainer from 'pages/pointsofinterest/list/PointsOfInterestListContainer';
import PointsOfInterestShowContainer from 'pages/pointsofinterest/show/PointsOfInterestShowContainer';
import ProductConfigurationContainer from 'pages/products/configuration/ProductConfigurationContainer';
import ProductLocalisationEditContainer from 'pages/products/productLocalisation/edit/ProductLocalisationEditContainer';
import ProductLocationContainer from 'pages/products/productLocation/ProductLocationContainer';
import ProductOccupancyContainer from 'pages/products/productOccupancy/ProductOccupancyContainer';
import ProductPropertiesCreate from 'pages/products/productProperties/create/ProductPropertiesCreateContainer';
import ProductPropertiesEdit from 'pages/products/productProperties/edit/ProductPropertiesEditContainer';
import ProductResourceContainer from 'pages/products/resource/ProductResourceContainer';
import ProductsCreateContainer from 'pages/products/create/ProductsCreateContainer';
import ProductsEditContainer from 'pages/products/edit/ProductsEditContainer';
import ProductsListContainer from 'pages/products/list/ProductsListContainer';
import ProductsShowContainer from 'pages/products/show/ProductsShowContainer';
import ProfileContainer from 'pages/profile/ProfileContainer';
import PropertiesCreateContainer from 'pages/properties/create/PropertiesCreateContainer';
import PropertiesEditContainer from 'pages/properties/edit/PropertiesEditContainer';
import PropertiesListContainer from 'pages/properties/list/PropertiesListContainer';
import PropertiesShowContainer from 'pages/properties/show/PropertiesShowContainer';
import PropertygroupsCreate from 'pages/propertygroups/create/PropertygroupsCreateContainer';
import PropertygroupsEditContainer from 'pages/propertygroups/edit/PropertygroupsEditContainer';
import PropertygroupsListContainer from 'pages/propertygroups/list/PropertygroupsListContainer';
import PropertygroupsShow from 'pages/propertygroups/show/PropertygroupsShowContainer';
import ReservationsListContainer from 'pages/reservations/list/ReservationsListContainer';
import ReservationsShow from 'pages/reservations/show/ReservationsShowContainer';
import SecurityContainer from 'pages/Security/SecurityContainer';
import SignUpContainer from 'pages/signUp/SignUpContainer';
import SubcategoriesCreateContainer from 'pages/subcategories/create/SubcategoriesCreateContainer';
import SubcategoriesEditContainer from 'pages/subcategories/edit/SubcategoriesEditContainer';
import SubcategoriesListContainer from 'pages/subcategories/list/SubcategoriesListContainer';
import SubcategoriesShowContainer from 'pages/subcategories/show/SubcategoriesShowContainer';
import UsersCreate from 'pages/users/create/UsersCreateContainer';
import UsersEditContainer from 'pages/users/edit/UsersEditContainer';
import UsersListContainer from 'pages/users/list/UsersListContainer';
import UsersShowContainer from 'pages/users/show/UsersShowContainer';
import UserYieldsCreateContainer from 'pages/account-yields/create/AccountYieldsCreateContainer';
import UserYieldsEditContainer from 'pages/account-yields/edit/AccountYieldsEditContainer';
import UserYieldsListContainer from 'pages/account-yields/list/AccountYieldsListContainer';
import WebhooksCreateContainer from 'pages/webhooks/create/WebhooksCreateContainer';
import WebhooksEditContainer from 'pages/webhooks/edit/WebhooksEditContainer';
import WebhooksListContainer from 'pages/webhooks/list/WebhooksListContainer';
import authHelper from 'helpers/auth';
import deprecated from 'routes/deprecated';
import utils from 'helpers/utils';
import { Switch } from 'react-router-dom';
import UserWalletsCreateContainer from 'pages/users/wallets/create/UserWalletsCreateContainer';
import MembershipSchedulesListContainer from 'pages/membership-schedules/list/MembershipSchedulesListContainer';
import MembershipScheduleCreateContainer from 'pages/membership-schedules/create/MembershipScheduleCreateContainer';
import MembershipScheduleShowContainer from 'pages/membership-schedules/show/MembershipScheduleShowContainer';
import MembershipScheduleEditContainer from 'pages/membership-schedules/edit/MembershipScheduleEditContainer';
import ProductMemberships from 'pages/product-memberships/list/ProductMemberships';
import ProductMembershipsCreate from 'pages/product-memberships/create/ProductMembershipsCreate';
import ProductMembershipShowContainer from 'pages/product-memberships/show/ProductMembershipShowContainer';
import ProductMembershipsEdit from 'pages/product-memberships/edit/ProductMembershipsEdit';
import UserProductMembershipCreateContainer from 'pages/users/product-memberships/create/UserProductMembershipCreateContainer';
import UserProductMembershipsEditContainer from 'pages/users/product-memberships/edit/UserProductMembershipsEditContainer';
import MembershipPoolsListContainer from 'pages/membership-pools/list/MembershipPoolsListContainer';
import MembershipPoolCreateContainer from 'pages/membership-pools/create/MembershipPoolCreateContainer';
import MembershipPoolEditContainer from 'pages/membership-pools/edit/MembershipPoolEditContainer';
import MembershipPoolsShowContainer from 'pages/membership-pools/show/MembershipPoolsShowContainer';

/**
 * This is will check if the value is able to be parsed. Otherwise we will leave it as it is.
 *
 * @param {string} id
 *
 * @returns {integer|string} parsedId
 */
const parseIdToInteger = (id) => {
    let parsedId = null;

    if (!id) {
        return parsedId;
    }

    if (utils.isNumeric(id)) {
        parsedId = parseInt(id, 10);
    }

    return parsedId;
};

const Routes = () => {
    return (
        <Switch>
            {
                // This will loop through all deprecated routes.
                deprecated.map((Route) => {
                    return Route;
                })
            }

            <Page path='/booking-tool/:id?' component={ BookingToolContainer } />

            <Page exact path='/bookings' render={ (props) => {
                return <BookingsListContainer actionType='BOOKINGS' resource='bookings' { ...props } />;
            } } />

            <Page exact path='/bookings/:id' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                if (authHelper.isProvider()) {
                    return <NotAllowedCard />;
                }

                return <BookingsEditContainer resource='bookings' id={ parseIdToInteger(id) } { ...props } />;
            } } />
            <Page exact path='/bookings/:id/show' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <BookingShowContainer resource='bookings' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/products/create' render={ (props) => {
                return <ProductsCreateContainer resource='products' { ...props } />;
            } } />

            <Page exact path='/products' render={ (props) => {
                return <ProductsListContainer actionType='PRODUCTS' resource='products' { ...props } />;
            } } />

            <Page exact path='/products/:id' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <ProductsEditContainer resource='products' id={ id } { ...props } />;
            } } />

            <Page exact path='/products/:id/show' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                if (authHelper.isReseller()) {
                    return <NotAllowedCard />;
                }

                return <ProductsShowContainer resource='products' id={ id } { ...props } />;
            } } />

            <Page exact path='/products/:productId/access-points/:id/show' render={ (props) => {
                const {
                    id,
                    productId,
                } = props.match.params;

                return <AccessPointShowContainer actionType='ACCESS_POINTS' resource='access-points' id={ parseIdToInteger(id) } productId={ productId } { ...props } />;
            } } />

            <Page exact path='/products/:productId/access-points/create' render={ (props) => {
                const {
                    productId,
                } = props.match.params;

                return <AccessPointCreateContainer actionType='ACCESS_POINTS' resource='access-points' productId={ productId } { ...props } />;
            } } />

            <Page exact path='/products/:productId/access-points/:id/' render={ (props) => {
                const {
                    id,
                    productId,
                } = props.match.params;

                return <AccessPointEditContainer actionType='ACCESS_POINTS' resource='access-points' id={ parseIdToInteger(id) } productId={ productId } { ...props } />;
            } } />

            <Page exact path='/products/:productId/access-points/:id/access-method/create' render={ (props) => {
                const {
                    id,
                    productId,
                } = props.match.params;

                return <AccessMethodCreateContainer actionType='ACCESS_POINTS' resource='access-points' id={ parseIdToInteger(id) } productId={ productId } parentResource='products' { ...props } />;
            } } />

            <Page exact path='/products/:productId/access-points/:id/access-method/:accessMethodId' render={ (props) => {
                const {
                    accessMethodId,
                    id,
                    productId,
                } = props.match.params;

                return <AccessMethodEditContainer actionType='ACCESS_POINTS' resource='access-points' subResource='access-points-access-methods' accessMethodId={ parseIdToInteger(accessMethodId) } id={ parseIdToInteger(id) } productId={ productId } parentResource='products' { ...props } />;
            } } />

            <Page exact path='/products/:id/properties/create' render={ (props) => {
                return <ProductPropertiesCreate resource='properties' { ...props } />;
            } } />

            <Page exact path='/products/:id/properties/:propertyId/edit' render={ (props) => {
                return <ProductPropertiesEdit resource='productProperties' { ...props } />;
            } } />

            <Page exact path='/products/:id/configuration' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                // This ID can be a string, so will not try to parse it like the others.
                return <ProductConfigurationContainer id={ id } resource='products' { ...props } />;
            } } />

            <Page exact path='/products/:id/location' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                // This ID can be a string, so will not try to parse it like the others.
                return <ProductLocationContainer id={ id } resource='products' { ...props } />;
            } } />

            <Page exact path='/products/:id/resource' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                // This ID can be a string, so will not try to parse it like the others.
                return <ProductResourceContainer id={ id } resource='products' { ...props } />;
            } } />

            <Page exact path='/products/:id/localisation/edit' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <ProductLocalisationEditContainer id={ id } resource='productLocalisation' { ...props } />;
            } } />

            <Page exact path='/products/:id/occupancy' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <ProductOccupancyContainer id={ id } resource='products' form='product-occupancy' { ...props } />;
            } } />

            <Page exact path='/@me/profile' isAccountAgnostic component={ ProfileContainer } />

            <Page exact path='/@me/security' isAccountAgnostic render={ (props) => {
                if (authHelper.isImpersonated() || authHelper.isAnonymous()) {
                    return <NotAllowedCard />;
                }

                return <SecurityContainer { ...props } />;
            } } />

            <Page exact path='/@me/invitations' isAccountAgnostic render={ (props) => {
                return <InvitationRequestsContainer resource='users' { ...props } />;
            } } />

            <Page exact path='/campaigns' render={ (props) => {
                return <CampaignsListContainer actionType='CAMPAIGN' resource='campaigns' { ...props } />;
            } } />

            <Page exact path='/campaigns/create' render={ (props) => {
                return <CampaignsCreateContainer resource='campaigns' { ...props } />;
            } } />

            <Page exact path='/campaigns/:id' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <CampaignsEditContainer resource='campaigns' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/campaigns/:id/show' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <CampaignsShowContainer resource='campaigns' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/discounts' render={ (props) => {
                return <DiscountsListContainer actionType='DISCOUNTS' resource='discounts' { ...props } />;
            } } />

            <Page exact path='/discounts/create' render={ (props) => {
                return <DiscountsCreateContainer resource='discounts' { ...props } />;
            } } />

            <Page exact path='/discounts/:id' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <DiscountsEditContainer resource='discounts' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/discounts/:id/show' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <DiscountsShowContainer resource='discounts' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/discounts/:parentId/discount-codes' render={ (props) => {
                const {
                    parentId,
                } = props.match.params;

                return <DiscountCodesListContainer actionType='DISCOUNT_CODES' discountId={ parseIdToInteger(parentId) } resource='discount-codes' { ...props } />;
            } } />

            <Page exact path='/discounts/:parentId/discount-codes/create' render={ (props) => {
                const {
                    parentId,
                } = props.match.params;

                return <DiscountCodesCreateContainer resource='discount-codes' discountId={ parseIdToInteger(parentId) } { ...props } />;
            } } />

            <Page exact path='/discounts/:parentId/discount-codes/:id' render={ (props) => {
                const {
                    parentId,
                    id,
                } = props.match.params;

                return <DiscountCodesEditContainer resource='discount-codes' discountId={ parseIdToInteger(parentId) } id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/accounts' render={ (props) => {
                return <AccountsListContainer actionType='ACCOUNTS' resource='accounts' { ...props } />;
            } } />

            <Page exact path='/accounts/create' render={ (props) => {
                return <AccountsCreate resource='accounts' { ...props } />;
            } } />

            <Page exact path='/accounts/:id' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <AccountsEditContainer resource='accounts' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/accounts/:id/show' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <AccountsShowContainer resource='accounts' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/current-account' render={ (props) => {
                return <CurrentAccountShowContainer resource='current-account' { ...props } />;
            } } />

            <Page exact path='/current-account/edit' render={ (props) => {
                return <CurrentAccountEditContainer resource='current-account' { ...props } />;
            } } />

            <Page exact path='/current-account/invitations' render={ (props) => {

                if (!authHelper.isOwner()) {
                    return <NotAllowedCard />;
                }

                return <InvitationsListContainer resource='accounts' { ...props } />;
            } } />

            <Page exact path='/current-account/invitations/create' render={ (props) => {

                if (!authHelper.isOwner()) {
                    return <NotAllowedCard />;
                }

                return <InvitationsCreateContainer resource='accounts' { ...props } />;
            } } />

            <Page exact path='/users' render={ (props) => {
                return <UsersListContainer actionType='USERS' resource='users' { ...props } />;
            } } />

            <Page exact path='/users/create' render={ (props) => {
                return <UsersCreate resource='users' { ...props } />;
            } } />

            <Page exact path='/users/:id' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <UsersEditContainer resource='users' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/users/:id/show' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <UsersShowContainer resource='users' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/users/:id/wallets/create' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <UserWalletsCreateContainer resource='users' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/users/:id/product-memberships/create' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <UserProductMembershipCreateContainer resource='users' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/users/:parentId/product-memberships/:id' render={ (props) => {
                const {
                    id,
                    parentId,
                } = props.match.params;

                return <UserProductMembershipsEditContainer resource='users' membershipId={ parseIdToInteger(id) } id={ parseIdToInteger(parentId) } { ...props } />;
            } } />

            <Page exact path='/api-keys' render={ (props) => {
                return <ApiKeysListContainer actionType='API_KEYS' resource='api-keys' { ...props } />;
            } } />

            <Page exact path='/api-keys/create' render={ (props) => {
                return <ApiKeysCreateContainer resource='api-keys' { ...props } />;
            } } />

            <Page exact path='/api-keys/:id' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <ApiKeysEditContainer resource='api-keys' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/webhooks' render={ (props) => {
                if (authHelper.isAdmin()) {
                    return <NotAllowedCard />;
                }

                return <WebhooksListContainer actionType='WEBHOOKS' resource='webhooks' { ...props } />;
            } } />

            <Page exact path='/webhooks/create' render={ (props) => {
                if (authHelper.isAdmin()) {
                    return <NotAllowedCard />;
                }

                return <WebhooksCreateContainer resource='webhooks' { ...props } />;
            } } />

            <Page exact path='/webhooks/:id' render={ (props) => {
                if (authHelper.isAdmin()) {
                    return <NotAllowedCard />;
                }

                const {
                    id,
                } = props.match.params;

                return <WebhooksEditContainer resource='webhooks' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/account_yields' render={ (props) => {
                return <UserYieldsListContainer actionType='ACCOUNT_YIELD' resource='account_yields' { ...props } />;
            } } />

            <Page exact path='/account_yields/create' render={ (props) => {
                return <UserYieldsCreateContainer resource='account_yields' { ...props } />;
            } } />

            <Page exact path='/account_yields/:id' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <UserYieldsEditContainer resource='account_yields' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/pointsofinterest' render={ (props) => {
                return <PointsOfInterestListContainer actionType='POINTS_OF_INTEREST' resource='pointsofinterest' { ...props } />;
            } } />

            <Page exact path='/pointsofinterest/create' render={ (props) => {
                return <PointsOfInterestCreate resource='pointsofinterest' { ...props } />;
            } } />

            <Page exact path='/pointsofinterest/:id' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <PointsOfInterestEditContainer resource='pointsofinterest' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/pointsofinterest/:id/show' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <PointsOfInterestShowContainer resource='pointsofinterest' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/reservations' render={ (props) => {
                return <ReservationsListContainer actionType='RESERVATIONS' resource='reservations' { ...props } />;
            } } />

            <Page exact path='/reservations/:id/show' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <ReservationsShow resource='reservations' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/propertygroups' render={ (props) => {
                return <PropertygroupsListContainer actionType='PROPERTYGROUPS' resource='propertygroups' { ...props } />;
            } } />

            <Page exact path='/propertygroups/create' render={ (props) => {
                return <PropertygroupsCreate resource='propertygroups' { ...props } />;
            } } />

            <Page exact path='/propertygroups/:id' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <PropertygroupsEditContainer resource='propertygroups' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/propertygroups/:id/show' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <PropertygroupsShow resource='propertygroups' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/properties' render={ (props) => {
                return <PropertiesListContainer actionType='PROPERTIES' resource='properties' { ...props } />;
            } } />

            <Page exact path='/properties/create' render={ (props) => {
                return <PropertiesCreateContainer resource='properties' { ...props } />;
            } } />

            <Page exact path='/properties/:id' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <PropertiesEditContainer resource='properties' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/properties/:id/show' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <PropertiesShowContainer resource='properties' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exac path='/booking-stats' render={ (props) => {
                return <BookingStatsListContainer actionType='BOOKING_STATS' resource='booking-stats' { ...props } />;
            } } />

            <Page exact path='/subcategories' render={ (props) => {
                return <SubcategoriesListContainer actionType='SUBCATEGORIES' resource='subcategories' { ...props } />;
            } } />

            <Page exact path='/subcategories/create' render={ (props) => {
                return <SubcategoriesCreateContainer resource='subcategories' { ...props } />;
            } } />

            <Page exact path='/subcategories/:id' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <SubcategoriesEditContainer resource='subcategories' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/subcategories/:id/show' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <SubcategoriesShowContainer resource='subcategories' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            {/* Membership schedules pages */}
            <Page exact path='/membership-schedules' render={ (props) => {
                return <MembershipSchedulesListContainer actionType='MEMBERSHIP_SCHEDULES' resource='membership-schedules' { ...props } />;
            } } />

            <Page exact path='/membership-schedules/create' render={ (props) => {
                return <MembershipScheduleCreateContainer actionType='MEMBERSHIP_SCHEDULES' resource='membership-schedules' { ...props } />;
            } } />

            <Page exact path='/membership-schedules/:id/show' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <MembershipScheduleShowContainer actionType='MEMBERSHIPS_SCHEDULES' resource='membership-schedules' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/membership-schedules/:id' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <MembershipScheduleEditContainer actionType='MEMBERSHIPS_SCHEDULES' resource='membership-schedules' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            {/* Invoice pages */}
            <Page exact path='/invoices' render={ (props) => {
                return <InvoicesListContainer actionType='INVOICES' resource='invoices' { ...props } />;
            } } />

            {/* Product membership pages */}
            <Page exact path='/product-memberships' render={ (props) => {
                return <ProductMemberships actionType='PRODUCT_MEMBERSHIPS' resource='product-memberships' { ...props } />;
            } } />

            <Page exact path='/product-memberships/create' render={ (props) => {
                return <ProductMembershipsCreate actionType='PRODUCT_MEMBERSHIPS' resource='product-memberships' { ...props } />;
            } } />

            <Page exact path='/product-memberships/:id/show' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <ProductMembershipShowContainer actionType='PRODUCT_MEMBERSHIPS' resource='product-memberships' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/product-memberships/:id' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <ProductMembershipsEdit actionType='PRODUCT_MEMBERSHIPS' resource='product-memberships' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/invoices/:id/show' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <InvoiceShowContainer actionType='INVOICES' resource='invoices' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/membership-pools' render={ (props) => {
                return <MembershipPoolsListContainer actionType='MEMBERSHIP_POOLS' resource='membership-pools' { ...props } />;
            } } />

            <Page exact path='/membership-pools/create' render={ (props) => {
                return <MembershipPoolCreateContainer actionType='MEMBERSHIP_POOLS' resource='membership-pools' { ...props } />;
            } } />

            <Page exact path='/membership-pools/:id' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <MembershipPoolEditContainer actionType='MEMBERSHIP_POOLS' resource='membership-pools' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page exact path='/membership-pools/:id/show' render={ (props) => {
                const {
                    id,
                } = props.match.params;

                return <MembershipPoolsShowContainer actionType='MEMBERSHIP_POOLS' resource='membership-pools' id={ parseIdToInteger(id) } { ...props } />;
            } } />

            <Page path='/login' component={ LoginContainer } isAccountAgnostic isPublic />

            <Page exact path='/register' component={ SignUpContainer } isAccountAgnostic isPublic />

            <Page path='/password-forgotten' component={ PasswordForgottenContainer } isAccountAgnostic isPublic />

            <Page exact path='/' component={ Dashboard } />

            <Page component={ PageNotFound } isAccountAgnostic isPublic />
        </Switch>
    );
};

Routes.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            access_direction: PropTypes.string,
            accessMethodId: PropTypes.string,
            parentId: PropTypes.number,
            productId: PropTypes.string,
            id: PropTypes.string,
        }),
    }),
};

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/Route.js